/* Skinsy how-to-apply page: the video facade.

   The still and the ▶ badge are the page; the player is built only when
   someone presses play. An iframe written up front fetches YouTube's whole
   player and sets its cookies on every view — the product page's lightbox
   has always built the frame on open for that reason, and this is the same
   code (skinsy-pdp.js, mountEmbed) without the lightbox around it. Nothing
   here is needed for the page to read: with no script the still and the
   steps are all there, and only the play button does nothing. */
(function () {
  'use strict';

  document.querySelectorAll('[data-skinsy-apply]').forEach(function (root) {
    var frame = root.querySelector('[data-apply-frame]');
    if (!frame) return;
    var play = frame.querySelector('[data-apply-play]');
    var poster = frame.querySelector('[data-apply-poster]');

    /* YouTube answers a missing maxresdefault with a 120x90 grey card at
       HTTP 200, so an error handler never fires. Measure instead: anything
       narrower than a real still is the placeholder, and hqdefault exists
       for every video. */
    function checkPoster() {
      if (!poster || !poster.dataset.applyFallback) return;
      if (poster.naturalWidth > 0 && poster.naturalWidth <= 120) {
        poster.src = poster.dataset.applyFallback;
        delete poster.dataset.applyFallback;
      }
    }
    if (poster && poster.tagName === 'IMG') {
      if (poster.complete) checkPoster();
      else poster.addEventListener('load', checkPoster);
    }

    function mount() {
      if (frame.querySelector('iframe')) return;
      var spec = String(frame.dataset.applyEmbed || '').split(':');
      var kind = spec[0];
      var id = spec[1];
      if (!id) return;

      var src =
        kind === 'vimeo'
          ? 'https://player.vimeo.com/video/' + encodeURIComponent(id) + '?autoplay=1&dnt=1'
          : 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0&playsinline=1';

      /* Hidden, not removed: an emptied frame would be a div with nothing
         in it, and Dawn's base.css hides every one of those. */
      if (poster) poster.hidden = true;
      if (play) play.hidden = true;

      var f = document.createElement('iframe');
      f.src = src;
      f.title = 'How to apply a Skinsy skin';
      f.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
      f.allowFullscreen = true;
      f.setAttribute('frameborder', '0');
      frame.appendChild(f);
    }

    if (play) play.addEventListener('click', mount);
  });
})();
